import React from "react";
import { Container } from "../../../../components";
import { Icon, Text, Heading } from "@telia/teddy";
import TEXT from "../../../text-consts";
import "./PrepaidReceipt.less";

export default function PrepaidReceipt() {
    return (
        <div className="prepaid-receipt">
            <Icon name="check-circle" />
            <Container className="prepaid-receipt__text">
                <Heading mb="100" as="h1" variant="title-200">
                    {TEXT.REGISTRATION.RECEIPT.HEADING}
                </Heading>
                <Text mb="100" dangerouslySetInnerHTML={{ __html: TEXT.REGISTRATION.RECEIPT.INGRESS }} />
                <Text mb="100">{TEXT.REGISTRATION.RECEIPT.FOOTER_TEXT}</Text>
            </Container>
        </div>
    );
}
